export default (string = '') => string.replace(/\D+/ig, ',').replace(/^,/, '').split(',');
